<template>
  <section :class="layoutClass">
    <slot />
  </section>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'

type Direction = 'row' | 'column' | 'row-reverse' | 'column-reverse'
const props = defineProps({
  direction: {
    type: String as PropType<Direction>,
    default: 'column'
  }
})
const layoutClass = computed(() => {
  return ['gfr-layout', `gfr-layout-${props.direction}`]
})
</script>
<style lang="scss" scoped>
.gfr-layout {
  @apply flex min-h-screen w-full;
}
.gfr-layout-row {
  @apply flex-row;
}
.gfr-layout-column {
  @apply flex-col;
}
.gfr-layout-row-reverse {
  @apply flex-row-reverse;
}
.gfr-layout-column-reverse {
  @apply flex-col-reverse;
}
</style>
